
import { getHostReadyClass } from '../utils/webcomponent';
import { ContextType } from '@dh-io-cscs/user-context-manager/dist';
import { PriceDisplayEventData } from '@dh-io-pls/price-display/dist/types';
import { computed, defineComponent, PropType, toRefs } from 'vue';
import { TFunction } from 'i18next';
import { EmhConfig, Product } from '@dh-io-emh/search-result-store';
import AdditionalData from './AdditionalData.vue';
import isEqual from 'lodash/isEqual';

export default defineComponent({
  name: 'EmhPurchasePriceInformation',
  components: {
    AdditionalData,
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    plsEnvironment: {
      type: String,
      required: true,
    },
    priceEventData: {
      type: Object as PropType<PriceDisplayEventData>,
    },
    t: {
      type: Function as PropType<TFunction>,
      required: true,
    },
    emhConfig: {
      type: Object as PropType<EmhConfig>,
      required: true,
    },
    userContext: {
      type: String as PropType<ContextType>,
      required: true,
    },
    footnoteReferences: {
      type: Array,
    },
    postCode: {
      type: String,
    },
  },
  emits: ['scrollToFootnotes', 'onPpBreakdownToggle', 'priceDisplayDataUpdate'],
  setup(props, { emit }) {
    const { priceEventData } = toRefs(props);
    let previousPriceEvent: CustomEvent<PriceDisplayEventData> | null = null;

    const hostCssClass = computed(() =>
      getHostReadyClass('emh-stage-campaign-item__purchase-price', Boolean(priceEventData?.value)),
    );

    const onPriceDisplayDataUpdate = async (event: CustomEvent<PriceDisplayEventData>): Promise<void> => {
      if (!isEqual(event.detail, previousPriceEvent?.detail)) {
        emit('priceDisplayDataUpdate', event);
        previousPriceEvent = event;
      }
    };

    const scrollToFootnotes = () => emit('scrollToFootnotes');
    const onPpBreakdownToggle = (toggle: boolean) => emit('onPpBreakdownToggle', toggle);

    return {
      hostCssClass,
      onPpBreakdownToggle,
      scrollToFootnotes,
      onPriceDisplayDataUpdate,
    };
  },
});
